import { render, staticRenderFns } from "./AssessmentExamData.vue?vue&type=template&id=b8d60896"
import script from "./AssessmentExamData.vue?vue&type=script&lang=js"
export * from "./AssessmentExamData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports